export const pt = {
  header: {
    status: "DISPONÍVEL",
    name: "LUAN LIMA",
    title: "SOFTWARE ENGINEER // WEBRTC, LIVEKIT & NESTJS SPECIALIST",
    timeLabel: "BRT (UTC-3):"
  },
  hero: {
    badge: "SOFTWARE ENGINEER",
    titleLine1: "ENGENHARIA DE SISTEMAS",
    titleHighlight: "ESCALÁVEIS & TEMPO REAL",
    titleLine2: "E APIS DE ALTA PERFORMANCE.",
    description: "Engenheiro de Software com mais de 12 anos de experiência. Especialista em NestJS, Node.js, WebRTC, LiveKit, entusiasta e defensor do ecossistema Bun & Elysia.js, construindo soluções corporativas escaláveis de alta concorrência.",
    btnLinkedin: "PERFIL LINKEDIN",
    btnGithub: "REPOSITÓRIOS GITHUB"
  },
  specSheet: {
    header: "// FICHA TÉCNICA",
    name: "LUAN LIMA",
    mainRoleLabel: "CARGO:",
    mainRoleVal: "Software Engineer",
    experienceLabel: "EXPERIÊNCIA:",
    experienceVal: "12+ Anos de Atuação",
    focusLabel: "ESPECIALIDADE:",
    focusVal: "NestJS, Node.js, WebRTC, LiveKit, Bun & Elysia",
    languagesLabel: "IDIOMAS:",
    languagesVal: "Português, Inglês",
    workModelLabel: "MODALIDADE:",
    workModelVal: "Remoto / PJ / Consultoria",
    locationLabel: "LOCALIZAÇÃO:",
    locationVal: "Brasil (UTC-3)",
    summary: "Engenheiro de Software com mais de 12 anos de experiência criando sistemas em tempo real, APIs de ultra-baixa latência e aplicações escaláveis no ecossistema JavaScript/TypeScript."
  },
  marquee: {
    headline: "// LINHA CONTÍNUA DE STACKS (PASSE O MOUSE PARA PAUSAR / CLIQUE PARA SELECIONAR)",
    badge: "FULLSTACK JS STACK"
  },
  matrix: {
    badge: "// MATRIZ DE COMPETÊNCIAS",
    title: "Stack Tecnológica & Engenharia",
    categoryAll: "TODOS",
    categories: {
      "Backend & Runtimes": "Backend & Runtimes",
      "Realtime & Architecture": "Realtime & Arquitetura",
      "Frontend & Mobile": "Frontend & Mobile",
      "Databases & ORMs": "Bancos & ORMs"
    }
  },
  inspector: {
    badge: "INSPECTOR DE TECNOLOGIA",
    header: "// TECNOLOGIA SELECIONADA",
    categoryLabel: "Categoria:",
    expLevelLabel: "NÍVEL DE ATUAÇÃO:",
    practicalAppLabel: "APLICAÇÃO PRÁTICA:",
    techNoteHeader: "// NOTA TÉCNICA",
    techNoteText: "Integrado ao ecossistema JavaScript/TypeScript de alta performance para garantir velocidade de desenvolvimento, tipagem consistente e escala.",
    statusActive: "STATUS: STACK ATIVA"
  },
  projects: {
    badge: "// PROJETOS & ATUAÇÃO",
    title: "Exemplos de Trabalhos",
    techFocusLabel: "FOCO TÉCNICO:",
    items: {
      "01": {
        title: "Executive Jiu-Jitsu — Mobile App (iOS & Android)",
        category: "MOBILE ENGINEERING & NATIVE EXPO ARCHITECTURE",
        description: "Engenharia de aplicativo móvel corporativo construído com Expo SDK 57 e React Native. Interface desenvolvida com componentes nativos de sistema (Apple Liquid Glass e SF Symbols), arquitetura de navegação com Expo Router, feedback tátil via expo-haptics, sincronização offline-first e pipeline automatizado de compilação multi-plataforma via Expo EAS Build.",
        metrics: "Expo SDK 57 • Native UI (Liquid Glass) • EAS Build"
      },
      "02": {
        title: "Plataforma WebRTC & SFU Realtime Infrastructure",
        category: "WEBRTC, LIVEKIT & HIGH-CONCURRENCY REALTIME",
        description: "Engenharia de infraestrutura para transmissão de áudio, vídeo e dados em tempo real com alta concorrência. Implementação de arquitetura WebRTC SFU utilizando LiveKit e WebSockets para garantir comunicação de ultra-baixa latência em escala.",
        metrics: "Ultra-Low Latency & WebRTC SFU Architecture"
      },
      "03": {
        title: "Arquitetura de Monorepos & APIs em Bun e Elysia.js",
        category: "HIGH-SPEED RUNTIMES & MONOREPO ARCHITECTURE",
        description: "Construção de ecossistema de microsserviços e monorepos escaláveis utilizando Bun, Workspaces e Elysia.js com ORM Drizzle. Otimização de tempo de compilação, bundling e respostas HTTP sub-50ms.",
        metrics: "High-Speed Bundling & Sub-50ms API Latency"
      },
      "04": {
        title: "Sistemas Corporativos Enterprise em NestJS & Clean Arch",
        category: "ENTERPRISE NODE.JS, DDD & CLEAN ARCHITECTURE",
        description: "Desenvolvimento e estruturação de arquitetura corporativa escalável em NestJS e Node.js. Aplicação estrita de Domain-Driven Design (DDD), Test-Driven Development (TDD) e integração com interfaces reativas em React e Angular.",
        metrics: "Enterprise DDD, TDD & 100% Type-Safe Contracts"
      }
    }
  },
  principles: {
    badge: "// PILARES TÉCNICOS",
    title: "Princípios de Engenharia",
    p1Code: "01 // REALTIME & PERFORMANCE",
    p1Title: "WebRTC & Runtimes Rápidos",
    p1Desc: "Aproveitamento de WebRTC, WebSockets e runtimes como Bun e Node.js otimizados para garantir comunicação em tempo real e baixa latência.",
    p2Code: "02 // DOMAIN-DRIVEN DESIGN (DDD)",
    p2Title: "Modelagem de Domínio & Clean Arch",
    p2Desc: "Desenvolvimento baseado em Domain-Driven Design (DDD), isolando regras de negócio em Bounded Contexts e Clean Architecture.",
    p3Code: "03 // TEST-DRIVEN DEVELOPMENT (TDD)",
    p3Title: "Qualidade & Testes Automatizados",
    p3Desc: "Desenvolvimento guiado por testes unitários e de integração (TDD) com Bun Test e Jest para máxima cobertura e refatorações seguras.",
    p4Code: "04 // CLEAN CODE & BOAS PRÁTICAS",
    p4Title: "Código Limpo & Princípios SOLID",
    p4Desc: "Escrita de código autodocumentável, coeso e legível, aplicando princípios SOLID e padrões de projeto para manutenção contínua."
  },
  contact: {
    badge: "LUAN_LIMA // CONTATO",
    headline: "Vamos conversar sobre novos projetos ou oportunidades.",
    subtitle: "Aberto para oportunidades em engenharia de software, arquitetura de sistemas JavaScript/WebRTC e consultoria técnica.",
    copyBtnDefault: "COPIAR ENDEREÇO DE E-MAIL",
    copyBtnSuccess: "E-MAIL COPIADO PARA O CLIPBOARD",
    copyright: "© 2026 LUAN LIMA. TODOS OS DIREITOS RESERVADOS."
  },
  stacks: {
    "bun-elysia": {
      category: "Backend & Runtimes",
      experience: "Alta Performance & High-Speed",
      highlight: "Runtime Ultra-rápido Bun, Servidor HTTP em Elysia.js, Bundling High-Speed & APIs com Baixíssima Latência"
    },
    "node": {
      category: "Backend & Runtimes",
      experience: "Especialista Profissional",
      highlight: "Arquitetura Corporativa de Microsserviços com NestJS e Node.js, Injeção de Dependências (DI), Decorators, Módulos, Express/Fastify & APIs RESTful Resilientes."
    },
    "ts-js": {
      category: "Backend & Runtimes",
      experience: "Base do Ecossistema",
      highlight: "Tipagem Estrita, Contratos Rígidos, Assincronismo Avançado & Event Loop em JavaScript (ES6+) e TypeScript"
    },
    "webrtc-ws": {
      category: "Realtime & Architecture",
      experience: "Especialidade em Tempo Real",
      highlight: "Arquitetura WebRTC SFU com LiveKit, transmissões P2P, DataChannels, streaming de áudio/vídeo & WebSockets em tempo real."
    },
    "api": {
      category: "Realtime & Architecture",
      experience: "Arquitetura de Sistemas",
      highlight: "APIs RESTful de alta resiliência, Event-Driven Architecture, WebSockets, Server-Sent Events (SSE) & contratos unificados."
    },
    "clean-tdd-ddd": {
      category: "Realtime & Architecture",
      experience: "Práticas de Engenharia",
      highlight: "Domain-Driven Design (DDD), Test-Driven Development (TDD), Clean Architecture, Princípios SOLID & Testes Automatizados"
    },
    "react-vue": {
      category: "Frontend & Mobile",
      experience: "Experiência Profissional",
      highlight: "Aplicações Web Escaláveis em React.js e Vue.js, Componentização Modular, Hooks & Reatividade Avançada"
    },
    "angular": {
      category: "Frontend & Mobile",
      experience: "Arquitetura Enterprise",
      highlight: "Desenvolvimento Web Reativo em Angular, SPAs Corporativas, Injeção de Dependências & RxJS"
    },
    "rn-expo": {
      category: "Frontend & Mobile",
      experience: "Desenvolvimento Mobile",
      highlight: "Aplicações Cross-Platform em React Native e Expo, EAS Builds & Integração com Ecossistema JS"
    },
    "styling": {
      category: "Frontend & Mobile",
      experience: "UI & Design Systems",
      highlight: "Tailwind CSS, Styled Components, Design Tokens, Interfaces Responsivas Cyber-Minimalistas & Animações"
    },
    "mysql-postgres": {
      category: "Databases & ORMs",
      experience: "Experiência Profissional",
      highlight: "Bancos Relacionais MySQL & PostgreSQL, Query Optimization, Índices & Modelagem de Dados Rígida"
    },
    "drizzle-prisma": {
      category: "Databases & ORMs",
      experience: "Experiência Profissional",
      highlight: "Type-safe SQL Queries, Migrações de Banco de Dados, Drizzle ORM, Prisma & Modelagem Relacional"
    }
  }
};
